import { defineStore, storeToRefs } from "pinia";
import type { Right, User } from "@/services/user/userTypes";
import { readonly } from "vue";

const useUserStore = defineStore("user", () => {
  const user = ref<User>();
  const arePricesVisible = ref<boolean>(true);
  const ssoAccessToken = ref<string | undefined>();
  const authPromise = ref<Promise<void> | null>(null);

  const isUserLoggedIn = computed(() => user.value !== undefined);
  const avatar = computed(() => user.value?.avatar);
  const userId = computed(() => user.value?.id);

  const hasRight = (right: Right): boolean => {
    return user.value?.rights.includes(right) ?? false;
  };

  return {
    user,
    userId,
    avatar,
    arePricesVisible,
    ssoAccessToken,
    authPromise,
    isUserLoggedIn: readonly(isUserLoggedIn),
    hasRight,
  };
});

export function useUser() {
  const store = useUserStore();
  const { user, userId, avatar, arePricesVisible, ssoAccessToken, authPromise, isUserLoggedIn } = storeToRefs(store);

  return {
    user,
    userId,
    avatar,
    arePricesVisible,
    ssoAccessToken,
    authPromise,
    isUserLoggedIn,
    hasRight: store.hasRight,
  };
}
